<template>
  <div class="box">
    <div class="photo">
      <a href="https://hw.sxbicsp.cn/static/video/index.html" target="_blank">
        <i class="el-icon-camera"></i>
        <span>拍照测试</span>
      </a>
    </div>
    <div class="box-title flex flex_align-items">
      <i class="iconfont icon-back pointer" style="color: #999999;font-size: 30px" @click="handleBack()"></i>
      <h2 class="box-title-center flex flex_align-items flex_justify-center">
        <img style="width: 80px;margin-right: 10px" src="~@/assets/logo.png" alt="">
        <span>用户注册</span>
      </h2>
    </div>
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item prop="loginName">
        <div><span>账号请填写手机号码，作为登录的凭证</span> </div>
        <el-input v-model="form.loginName" placeholder="账号（手机号码）"></el-input>
      </el-form-item>

      <el-form-item prop="code">
        <el-row :gutter="20">
          <el-col :span="14">
            <el-input v-model="form.code" placeholder="验证码"></el-input>
          </el-col>
          <el-col :span="10">
            <el-button @click="getCode" type="primary" style="width: 120px">{{ CODE_TEXT }}</el-button>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item prop="password">
        <el-input type="password" v-model="form.password" placeholder="注册密码"></el-input>
      </el-form-item>

      <el-form-item prop="queryPassword">
        <el-input type="password" v-model="form.queryPassword" placeholder="确认密码"></el-input>
      </el-form-item>

    </el-form>
    <el-button :loading="loading" @click="handleRegister('form')" type="primary" style="width: 100%">立即注册</el-button>
  </div>
</template>

<script>
export default {
  name: "register-from",
  data() {
    let checkPhone = (rule, value, callback) => { // 手机号码验证
      if (!value) {
        return callback(new Error('手机号码不能为空'));
      }
      setTimeout(() => {
        let patt = /^\d{11}$/;
        if (!patt.test(value)) {
          callback(new Error('请输入正确的手机号码'));
        } else {
          callback();
        }
      }, 1000);
    };

    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if(value.length < 6) {
        callback(new Error('密码长度大于6位数'));
      } else {
        callback();
      }
    };

    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      form: {
        loginName: '', // 用户名
        password: '', // 密码
        queryPassword: '', // 确认密码
        code: '', // 验证码
      },
      rules: {
        loginName: [
          { required: true, validator: checkPhone, trigger: ['blur', 'change'] },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: ['blur', 'change'] },
        ],
        password: [
          { required: true, validator: validatePass, trigger: ['blur', 'change'] },
        ],
        queryPassword: [
            { required: true, validator: validatePass2, trigger: ['blur', 'change'] },
        ]
      },
      CODE_TEXT: '获取验证码',
      isGetCode: false,
    }
  },
  methods: {
    handleBack() {
      this.$emit('isShowRegister')
    },
    handleRegister(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post(this.$API.REGISTER, {
            ...this.form
          }).then( res => {
            console.log(res)
            if(res.code === 200) {

              this.$message({
                message: '注册成功，即将返回登录页面',
                type: 'success'
              });
              setTimeout(() => {
                for(let i in this.form) {
                  this.form[i] = '' // 初始化
                }
                this.$emit('isShowRegister')
              }, 1000)
            } else this.$message.error(res.msg);
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async getCode() { // 获取验证码
      // 为防止计时器增加
      if( this.isGetCode) return;
      // 验证
      if(!this.form.loginName) return this.$message.error('请输入手机号码');

      // 验证手机号码是否呗使用
      let isCheckName = await this.isCheckEXIST(this.form.loginName)
      if(isCheckName.code !== 200 ) return this.$message.error('该账号已被使用');
      this.loading = true
      // 获取验证码
      let mobilePhone = await this.getMobilePhone(this.form.loginName)
      if(mobilePhone.code !== 200) return this.$message.error(mobilePhone.msg);
      else {
        this.$message({
          message: mobilePhone.msg,
          type: 'success'
        });
      };
      this.isGetCode = true;
      this.loading = false
      // 计时器 60
      let count = 60
      let timer = setInterval(() => {
        count--
        this.CODE_TEXT = count
        if (count === 0) {
          console.log(count)
          setTimeout(() => {
            this.CODE_TEXT = '获取验证码';
            this.isGetCode = false;
            clearInterval(timer);
          }, 100)
        }
      }, 1000)
    },
    isCheckEXIST(loginName) { // 检验是否重名
      return new Promise( resolve => {
        this.$post(this.$API.CHECK_IS_EXIST, {
          loginName: loginName
        }).then( res => {
          resolve(res)
        }).catch(err => {
          console.log(err)
        })
      })
    },
    getMobilePhone(loginName) { // 获取手机验证码
      return new Promise( resolve => {
        this.$post(this.$API.CODE, {
          loginName: loginName
        }).then( res => {
          resolve(res)
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  transform: translateY(-50%);
  box-shadow: 2px 2px 8px rgb(0 0 0 / 5%);
  border-radius: 8px;
  padding: 40px 30px;
  box-sizing: border-box;
  width: 400px;


  &-title {
    margin-bottom: $spacing-row-lg;

    &-center {
      flex: 1;
      text-align: center;

      span {
        font-size: $font-size-lg;
        font-weight: 600;
      }
    }
  }

  .layout-tip {
    font-size: $font-size-base;
    margin-top: 10px;

    a {
      color: $font-text-color-grey;
    }
  }
}

.photo {
  cursor: pointer;
  position: absolute;
  top: -80px;
  right: 0;
  font-size: 26px;


  a {
    color: #2196f3;
    display: flex;
    align-items: center;
    span {
      padding-left: 10px;
      font-size: 20px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
